import { getFirstLetter } from '../../helpers/avatarHelpers';

export default function AppAvatar({ name }) {
    const firstLetter = getFirstLetter(name);
    return (
        <div className="m-1 mr-2 w-[37px] h-[37px] relative flex justify-center items-center rounded-full bg-[#eaeaea] text-[15px] text-black uppercase font-bold font-roboto ">
            {firstLetter}
        </div>
    );
}
